import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportSideBarComponent } from '../report-side-bar/report-side-bar.component';
import { ReportViewComponent } from '../report-view/report-view.component';

@Component({
  selector: 'reporting-layout',
  standalone: true,
  imports: [CommonModule, ReportSideBarComponent, ReportViewComponent],
  templateUrl: './report-layout.component.html',
  styleUrls: ['./report-layout.component.scss']
})
export class ReportLayoutComponent {}
